
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    export class _ECommOrderSelectGrid extends _Ext.GridBase<SalesOrder.SalesOrderItemsRow, any> {
        protected getColumnsKey() { return 'SalesOrder.SalesOrderItems'; }
        protected getDialogType() { return <any>SalesOrder.SalesOrderItemsDialog; }
        protected getIdProperty() { return SalesOrder.SalesOrderItemsRow.idProperty; }
        protected getLocalTextPrefix() { return SalesOrder.SalesOrderItemsRow.localTextPrefix; }
        //protected getService() { return Retail.SalesOrderMagentoImportService.baseUrl; } 
     
        constructor(container: JQuery, options) {
            super(container, options);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            this.slickGrid.setOptions({ rowHeight: 30 });

            return this;
        }

        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize(); // *** If you want to make it autoresize when grid is loaded, use: new Slick.AutoColumnSize(true);
            grid.registerPlugin(this.autoSize);


            return grid;
        }

        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        get selectedItems(): SalesOrder.SalesOrderItemsRow[] {
                var _this = this;
                return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
            }

        protected usePager() { return true; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 20;
            return opt;
        }

        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;

            return true;
        }
        
    } 
}